module.exports = __webpack_public_path__ + "img/PDF_LOGO.0722d75d.svg";